import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { config } from '../lib/config';
import { DayCheckinLogo } from './DayCheckinLogo';

export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="bg-canvas sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo and Brand */}
          <Link to="/" className="flex items-center space-x-3 cursor-pointer group">
            <DayCheckinLogo className="w-8 h-8" />
            <span className="text-xl font-semibold text-white group-hover:text-cyan transition-colors">
              {config.siteName}
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <a
              href="#features"
              className="text-text-secondary hover:text-white transition-colors cursor-pointer text-sm font-medium"
            >
              Features
            </a>
            <a
              href={config.loginUrl}
              className="text-text-secondary hover:text-white transition-colors cursor-pointer text-sm font-medium"
            >
              Login
            </a>
            <a
              href={config.signupUrl}
              className="px-5 py-2 bg-[#FFD93D] text-black font-mono text-sm uppercase tracking-wider hover:opacity-90 transition-opacity cursor-pointer"
            >
              Initialize
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-text-secondary hover:text-white cursor-pointer"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 space-y-4 border-t border-border-muted">
            <a
              href="#features"
              className="block w-full text-left text-text-secondary hover:text-white transition-colors cursor-pointer text-sm"
            >
              Features
            </a>
            <a
              href={config.loginUrl}
              className="block w-full text-left text-text-secondary hover:text-white transition-colors cursor-pointer text-sm"
            >
              Login
            </a>
            <a
              href={config.signupUrl}
              className="block w-full text-center px-5 py-2 bg-[#FFD93D] text-black font-mono text-sm uppercase tracking-wider cursor-pointer"
            >
              Initialize
            </a>
          </div>
        )}
      </div>
      {/* Sun separator line */}
      <div className="h-px bg-[#FFD93D]"></div>
    </nav>
  );
}
